/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ClassroomDisciplineListItemViewModel } from "../types/ClassroomDisciplineListItemViewModel.ts";
import { eClassRoomDisciplinesStatusSchema } from "./eClassRoomDisciplinesStatusSchema.ts";
import { eClassTypeSchema } from "./eClassTypeSchema.ts";

export const classroomDisciplineListItemViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  companyId: z.number().int().nullish(),
  companyName: z.string().nullish(),
  courseId: z.number().int().nullish(),
  courseName: z.string().nullish(),
  classStudentId: z.number().int().nullish(),
  classStudentName: z.string().nullish(),
  classModuleId: z.number().int().nullish(),
  classModuleName: z.string().nullish(),
  disciplineId: z.number().int().nullish(),
  disciplineName: z.string().nullish(),
  teacherName: z.string().nullish(),
  dateStart: z.optional(z.string().datetime()),
  dateFinish: z.optional(z.string().datetime()),
  status: z.optional(
    z
      .lazy(() => eClassRoomDisciplinesStatusSchema)
      .describe("1 = Planned | 2 = Finished | 3 = Canceled | 4 = Confirmed | "),
  ),
  type: z.optional(
    z.lazy(() => eClassTypeSchema).describe("1 = Normal | 2 = OnDemand | "),
  ),
  recurrenceClassroomDisciplineId: z.number().int().nullish(),
  hasContent: z.optional(z.boolean()),
  slides: z.optional(z.number().int()),
  classAvailable: z.optional(z.boolean()),
  active: z.optional(z.boolean()),
}) as unknown as ToZod<ClassroomDisciplineListItemViewModel>;
